<template>
	<v-row no-gutters>
		<v-col cols="12" xs="12" sm="12" :align="centered ? 'center' : null">
			<v-alert text outlined prominent :color="color" :icon="icon">
				<span class="subtitle-1" v-if="title">
					<strong>{{ title }}</strong>
				</span>
				<v-divider class="my-1 error" style="opacity: 0.22" v-if="title && (message || actionbutton)"></v-divider>
				<span v-if="message" v-html="message"></span>
				<v-row justify="center" v-if="actionbutton">
					<v-col cols="6" xs="6" sm="3">
						<action-button small @click="clicked()" outlined :text="actionbutton"></action-button>
					</v-col>
				</v-row>
			</v-alert>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data: () => ({}),
	props: {
		title: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: "main_text_color",
		},
		message: {
			type: String,
			default: null,
		},
		actionbutton: {
			type: String,
			default: null,
		},
		centered: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		icon() {
			let default_icon = "fas fa-info-circle";
			switch (this.color) {
				case "success":
					default_icon = "fas fa-check";
					break;
				case "warning":
					default_icon = "fas fa-exclamation-triangle";
					break;
				case "error":
					default_icon = "fas fa-exclamation-triangle";
					break;
				case "main_text_color":
					default_icon = "fas fa-info-circle";
					break;
				default:
					break;
			}
			return default_icon;
		},
	},
	methods: {
		clicked() {
			this.$emit("action");
		},
	},
};
</script>
